import {cpServiceGet} from 'api';
import {sendSentryException} from 'utils/error-handling';

/**
 * Gets the facility microclimate metadata
 * @param {number|string} facilityId - The facility id.
 * @returns {Promise<MicroclimateMetaData>}
 * @throws {Error}
 *
 * @see '/control-panel-service/v1/facilities/{facilityId}/microclimate'
 */
const getMicroclimateMetadata = async (facilityId) => {
    try {
        const {
            data: {meta},
        } = await cpServiceGet(`facilities/${facilityId}/microclimate`);

        return meta;
    } catch (error) {
        sendSentryException(error);

        throw error;
    }
};

export default getMicroclimateMetadata;
